import Signin from "./Users/Signin";
import Signup from "./Users/Signup";
import Landing from "./Home/Landing";
import JobView from "./Jobs/JobView";
import Profile from "./Users/Profile";
import Settings from "./Users/Settings";
import JobCreation from "./Jobs/JobCreation";
import Dashboard from "./Dashboard/Dashboard";
import ResetPassword from "./Users/ResetPassword";
import SignupSurveyor from "./Users/SignupSurveyor";
import ForgotPassword from "./Users/ForgotPassword";
import BrowseGuest from "./BrowseGuest/BrowseGuest";
import CompanyUserMgt from "./Users/CompanyUserMgt";
import AdminDashboard from "./Dashboard/AdminDashboard";
import ElevationForm from "./ElevationForm/ElevationForm";
import Questionnaire from "./ElevationForm/Questionnaire";
import AllJobs from "./Jobs/AllJobs";
import SurveyRequest from "./SurveyRequest/SurveyRequest";

export {
  Signin,
  Signup,
  Landing,
  JobView,
  Profile,
  Settings,
  Dashboard,
  BrowseGuest,
  JobCreation,
  ResetPassword,
  SignupSurveyor,
  ForgotPassword,
  CompanyUserMgt,
  AdminDashboard,
  ElevationForm,
  Questionnaire,
  AllJobs,
  SurveyRequest,
};



// WEBPACK FOOTER //
// ./src/pages/index.js